function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 = /*#__PURE__*/React.createElement("style", {
  type: "text/css"
}, "\n\t.st1{fill:#FC0019;}\n");

var _ref3 = /*#__PURE__*/React.createElement("path", {
  id: "Combined-Shape",
  className: "st1",
  d: "M0.3,15.6C6.5,9.1,13,8.8,19.7,14.8c0.4,0.4,0.4,1,0,1.3l0,0l-2.3,2.4 c-0.4,0.4-1,0.4-1.4,0c-0.9-0.8-1.9-1.4-2.9-1.9c-0.3-0.2-0.5-0.5-0.5-0.8l0,0l-0.1-3c-3-0.8-2.3-0.7-5.2,0.3l0,0l0.1,3 c0,0.3-0.1,0.5-0.3,0.7C7.1,17,7,17,6.9,17.1c-1,0.5-1.9,1.2-2.8,2.1c-0.4,0.4-1,0.4-1.4,0l0,0L0.3,17C-0.1,16.6-0.1,16,0.3,15.6z  M5.4,14.1c-1.1,0.6-2.1,1.3-3.1,2.1l0,0l1.1,1c0.6-0.6,1.3-1.1,2-1.5l0,0L5.4,14.1z M14.5,13.7l0.1,1.6c0.7,0.4,1.5,0.8,2.1,1.4 l0,0l1-1C16.6,14.8,15.6,14.2,14.5,13.7L14.5,13.7z M9,0.5V2H5.5L10,6.5l6-6l1,1l-7,7L4.5,3v3.5H3v-6H9z"
});

var SvgMissedCall = function SvgMissedCall(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    x: "0px",
    y: "0px",
    viewBox: "0 0 20 20",
    style: {
      enableBackground: "new 0 0 20 20"
    },
    xmlSpace: "preserve",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _ref2, _ref3);
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgMissedCall, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/missed_call.f432ddcb.svg";
export { ForwardRef as ReactComponent };